import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function Media({ children, hiddenOnMobile, icon, small, title }) {
  return (
    <div className={classes({
      "media": true,
      "media--small": small,
      "hidden--mobile": hiddenOnMobile
    })}>
      <div className="media_graphic">
        <i className={icon} />
      </div>

      <div className="media_body">
        <h2 className="media_heading">
          {title}
        </h2>

        <p className="media_text">
          {children}
        </p>
      </div>
    </div>
  );
});
